export enum ChatChannelType {
  ASSIGNMENT = 'assignment',
  GLOBAL = 'global'
}
